import { ScoreTriggerEditable } from '@/ui/DTO';

export interface ChecklistNotifiableEditable {
  id?: number;
  entityItemSpecificAssignments: boolean;
  users: Array<number>;
  externalAssociates: Array<string>;
  scoreTrigger: null | ScoreTriggerEditable;
}

export const emptyChecklistNotifiable = (): ChecklistNotifiableEditable => ({
  entityItemSpecificAssignments: false,
  users: [],
  externalAssociates: [],
  scoreTrigger: null,
});
